import React from 'react';
import {
  ShowController,
  ShowView,
  TabbedShowLayout,
  Tab, CardActions, ListButton,
} from 'react-admin';
import { CircularProgress, Card, CardContent } from '@material-ui/core';

import './styles.css';
import BasicInformation from './children/BasicInformation_Show';
import Identity from './children/Identity_Show';

import TrustedContact from './children/TrustedContact_Show';
import EmploymentFinances from './children/EmploymentFinances_Show';
import UserHistoryAndDocs from './children/UserHistoryAndDocs_Show';
import FolioData from './children/FolioData_Show';
import { ADMIN_LEVELS, getAdminLevel } from '../../authProvider';
import ShowActions from './actions/ShowActions';

const Title = ({ record }) => (<span>User: <strong>{record.firstName} {record.middleName ? `${record.middleName}` : ''}{record.lastName}</strong> ({record.email})</span>);

const Actions = ({
  basePath,
  data,
  resource,
  isLoading,
}) => {
  const adminLevel = getAdminLevel();
  const hasClosedAccount = data && data.account && data.account.isClosed;
  return (
    <CardActions>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        alignItems: 'flex-start',
      }}
      >
        <ListButton basePath={basePath} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        { adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN && !hasClosedAccount &&
        <ShowActions
          data={data}
          resource={resource}
          basePath={basePath}
          isLoading={isLoading}
        /> }
      </div>
    </CardActions>
  );
};

export default ({ permissions, ...props }) => (
  <ShowController {...props}>
    {(controllerProps) => {
        if (controllerProps.isLoading && !controllerProps.record) {
          return <Card><CardContent style={{ textAlign: 'center' }}><CircularProgress /><br /><br /><span className="normalField">Fetching data</span></CardContent></Card>;
        }
       return (
         <ShowView
           {...props}
           {...controllerProps}
           title={<Title />}
           actions={<Actions path={props.location.pathname} {...controllerProps} />}
         >
           <TabbedShowLayout>
             <Tab label="Basic">
               <BasicInformation />
             </Tab>
             {controllerProps.record && controllerProps.record.signUpCompletedAt && <Tab label="Identity"><Identity /></Tab>}
             {controllerProps.record && controllerProps.record.trustedContact && <Tab label="Trusted Contact"><TrustedContact /></Tab>}
             {controllerProps.record && controllerProps.record.signUpCompletedAt && <Tab label="Employment, Finances &amp; Disclosures" style={{ maxWidth: 'none' }}><EmploymentFinances /></Tab>}
             <Tab label="Action History &amp; Documents">
               <UserHistoryAndDocs />
             </Tab>
             {controllerProps.record && controllerProps.record.signUpCompletedAt && <Tab label="FOLIO Data"><FolioData /></Tab>}
           </TabbedShowLayout>
         </ShowView>
      );
  }}
  </ShowController>
);



// WEBPACK FOOTER //
// ./src/components/User/Show.jsx